import React from 'react';
import { NoteProps, NotesProps } from './types';
import { Row } from 'react-bootstrap';
import style from './style.module.scss';
import { paths } from 'config/path_helpers';
import { pluralize } from 'utilities/pluralize';
import { TabButton } from '@magoosh/lib/button';
import NotesIllustration from '../../assets/notes_illustration.svg';
import cx from 'classnames';
import { PageCard } from '../../lib/page_card';
import { Wrapper } from '../../lib/wrapper';
import Icon from '../../assets/icons';
import { HeaderWithIllustration } from '../../lib/header_with_illustration';

const Notes: React.FC<NotesProps> = (props: NotesProps) => {
  const currentSection = props.sections.filter((section) => section.selected)[0];
  return (
    <Wrapper>
      <div className="u-margin-V-m">
        <a href={paths.dashboard()}>
          <strong>Home</strong>
        </a>{' '}
        {'>'} <span>Notes</span>
      </div>
      <PageCard>
        <HeaderWithIllustration
          illustration={NotesIllustration}
          illustrationAltText="Students leaping with excitement in front of a note"
          icon={<Icon iconType={'Notes'} fill={'#007BE8'} />}>
          <h2>Notes</h2>
          <p>
            Use notes to help you remember key concepts or strategies. You may take notes on any lesson video
            or answer explanation.
          </p>
        </HeaderWithIllustration>

        <Row className={style.noteTabs}>
          {props.sections.map((section) => {
            if (section.selected) {
              return (
                <TabButton disabled={true} key={section.slug}>
                  {section.name}
                </TabButton>
              );
            } else {
              return (
                <TabButton key={section.slug} href={paths.examSectionNotes(section.slug)}>
                  {section.name}
                </TabButton>
              );
            }
          })}
        </Row>

        <h3 className="u-margin-B-n">{currentSection.name} Notes</h3>
        <small>{pluralize(props.lessonNotes.length + props.questionNotes.length, 'Note', 'Notes')}</small>

        <div className={style.notes}>
          <div className={cx(style.notesColumn)}>
            <h4>Lessons</h4>
            {props.lessonNotes.length === 0 ? (
              <>
                <p>You have not taken any notes on {currentSection.name} lessons.</p>
                <a href={paths.dashboard()}>Go to Study Plan</a>
              </>
            ) : (
              <>
                <p>{pluralize(props.lessonNotes.length, 'Note', 'Notes')}</p>
                {props.lessonNotes.map(renderNote)}
              </>
            )}
          </div>
          <div className={cx(style.notesColumn)}>
            <h4>Questions</h4>
            {props.questionNotes.length === 0 ? (
              <>
                <p>You have not taken any notes on {currentSection.name} questions.</p>
                <a href={paths.answers()}>Go to Review</a>
              </>
            ) : (
              <>
                <p>{pluralize(props.questionNotes.length, 'Note', 'Notes')}</p>
                {props.questionNotes.map(renderNote)}
              </>
            )}
          </div>
        </div>
      </PageCard>
    </Wrapper>
  );
};

const renderNote = (note: NoteProps) => {
  return (
    <div className={style.note} key={note.id}>
      <p>{note.text}</p>
      <p>
        {note.link ? (
          <>
            <a href={note.link}>{note.linkText}</a> on {note.timestamp}
          </>
        ) : (
          <>
            <span>{note.linkText}</span> on {note.timestamp}
          </>
        )}
      </p>
    </div>
  );
};

export default Notes;
